import type { TranslatedFormField } from './types';

export type Field = Pick<TranslatedFormField, 'name' | 'options'>;
type OptionValue = NonNullable<Field['options']>[number][0];

export function getFieldOptionLabel(field: Field, optionName: OptionValue): string | undefined {
    const { options } = field;

    if (!options) {
        return undefined;
    }

    if (options instanceof Map) {
        throw new Error(
            `Expected '${field.name}' options to be an array of entries, but received a Map.`
        );
    }

    return new Map(options).get(optionName);
}
